import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getTutorDetails,
  deleteTutor,
  updateTutor,
  updateTutorStatus,
  getTutorList,
} from "../../services/Academic-Services";
import AddTutorForm from "../../components/FormComponents/AddTutor";
const TutorTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getTutorList}
        deleteRow={deleteTutor}
        updateStatus={updateTutorStatus}
        tab1={"Academic"}
        tab2={"Tutor"}
        AddForm={AddTutorForm}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default TutorTable;
